/**
 * Typed 401 error for silent request variants: background flows (polling)
 * throw it instead of hard-redirecting to /error_permission, so callers can
 * stop quietly when the session expires without any user-facing toast.
 * Pure module (no imports) so the guard is unit-testable.
 */

export class UnauthorizedError extends Error {
  readonly unauthorized = true

  constructor() {
    super('Unauthorized')
    this.name = 'UnauthorizedError'
  }
}

export const isUnauthorizedError = (error: unknown): error is UnauthorizedError =>
  error instanceof UnauthorizedError
